<template>
  <div class="column bg-white text-grey-8 rounded-borders no-wrap">
    <SAIStepper
      class="col-grow user-profile-stepper column"
      :value="activePage"
      :swipeable="false"
      @input="$emit('update:page', $event)"
      :flat="true"
    >
      <SAIStep :name="employerKey">
        <UserProfileEmployer
          class="scroll no-wrap"
          :user="user"
          :name-error="errors['formUser.companyName']"
          :email-error="errors['formUser.companyEmail']"
          :disable="saving"
          :loading="saving"
          :name="name"
          :corporate-account-signup="corporateAccountSignup"
          @next="$emit('save', $event)"
          @update:user="$emit('update:user', $event)"
          @update:corporate-account-signup="
            $emit('update:corporate-account-signup', $event)
          "
        />
      </SAIStep>
      <SAIStep :name="organisationSelectionKey">
        <userProfileOrganisationSelection
          class="scroll no-wrap"
          :error="errors['selectedOrganisation']"
          :saving="savingUserOrganisation || saving"
          :loading="loadingUserOrganisations"
          :selected-organisation="selectedOrganisation"
          :user-organisations="userOrganisations"
          @next="$emit('save', $event)"
          @update:organisation="$emit('update:selected-organisation', $event)"
        />
      </SAIStep>
      <SAIStep :name="employmentTypeKey">
        <UserProfileEmploymentType
          class="scroll no-wrap"
          :user="user"
          :disable="saving"
          :loading="saving"
          :employment-options="employmentOptions"
          :header-img="employmentTypeImg"
          @next="$emit('save', $event)"
          @update:user="$emit('update:user', $event)"
        />
      </SAIStep>
      <SAIStep :name="postcodeKey">
        <UserProfilePostcode
          class="scroll no-wrap"
          :user="user"
          :postcode-error="errors['formUser.postcode']"
          :disable="saving"
          :loading="saving"
          :header-img="postcodeImg"
          @next="$emit('save', $event)"
          @update:user="$emit('update:user', $event)"
        />
      </SAIStep>
      <SAIStep :name="contactNumberKey">
        <UserProfileContactNumber
          class="scroll no-wrap"
          :user="user"
          :contact-number-error="errors['formUser.contactNumber']"
          :disable="saving"
          :loading="saving"
          :header-img="contactImg"
          @next="$emit('save', $event)"
          @update:user="$emit('update:user', $event)"
        />
      </SAIStep>
      <template v-slot:navigation>
        <QStepperNavigation>
          <SAIPageDots
            :dots="pageDots"
            @input="$emit('update:page', $event.id)"
          />
          <p
            :class="[
              'text-body1  text-weight-medium text-center q-mt-lg',
              {
                'cursor-pointer text-primary': !saving,
                'text-grey-6': saving
              }
            ]"
            @click="$emit('skip')"
          >
            Skip
          </p>
        </QStepperNavigation>
      </template>
    </SAIStepper>
  </div>
</template>

<script>
import { QStepperNavigation } from 'quasar';
import { SAIStepper, SAIStep, SAIPageDots } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileStepper',
  props: {
    dismissible: Boolean,
    saving: Boolean,
    name: String,
    loadingUserOrganisations: Boolean,
    savingUserOrganisation: Boolean,
    corporateAccountSignup: Boolean,
    employmentTypeImg: String,
    postcodeImg: String,
    contactImg: String,
    selectedOrganisation: {
      type: Object,
      default: () => ({})
    },
    userOrganisations: {
      type: Array,
      default: () => []
    },
    employmentOptions: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    step: {
      type: String,
      default: undefined
    },
    pageDots: {
      type: Array,
      required: true
    },
    activePage: {
      type: String,
      required: true
    },
    employerKey: {
      type: String,
      required: true
    },
    employmentTypeKey: {
      type: String,
      required: true
    },
    postcodeKey: {
      type: String,
      required: true
    },
    contactNumberKey: {
      type: String,
      required: true
    },
    organisationSelectionKey: {
      type: String,
      required: true
    }
  },
  components: {
    SAIStepper,
    SAIStep,
    SAIPageDots,
    QStepperNavigation,
    UserProfileEmployer: () => import('../user-profile-employer'),
    UserProfileEmploymentType: () => import('../user-profile-employment-type'),
    UserProfileContactNumber: () => import('../user-profile-contact-number'),
    UserProfilePostcode: () => import('../user-profile-postcode'),
    userProfileOrganisationSelection: () =>
      import('../user-profile-organisation-selection')
  }
};
</script>

<style lang="sass" scoped>
.user-profile-stepper::v-deep
  .q-stepper__step-content,
  .q-stepper__step-inner
    height: 100%

  .q-stepper__step-inner
    padding-top: 0
</style>
